import {useMemo} from 'react'
import {formatWarning} from '../../../lib/lvs-foni'
import {computeSignLayout, type SignDef, type SignInput} from '../../../lib/sign-catalog'
import {FoniCanvas, FoniParamsTable} from '../../foni'
import {WarningPill} from '../../ui/warning-pill'

export interface PreviewStepProps {
    readonly def: SignDef
    readonly input: SignInput
}

export function PreviewStep({def, input}: PreviewStepProps) {
    const {layout, arrow} = useMemo(() => computeSignLayout(def, input), [def, input])

    return (
        <section className='space-y-4'>
            {layout.warnings.length > 0 && (
                <div className='flex flex-wrap gap-2'>
                    {layout.warnings.map((w, i) => (
                        <WarningPill key={i}>{formatWarning(w)}</WarningPill>
                    ))}
                </div>
            )}

            <FoniCanvas
                layout={layout}
                bgColor={input.bgColor}
                strike={input.strike}
                arrow={arrow}
                idSuffix='preview'
            />

            <FoniParamsTable
                layout={layout}
                bgColor={input.bgColor}
                strike={input.strike}
            />
        </section>
    )
}
